<app-nano-player *ngIf="videoEnabled" [config]="config"></app-nano-player>

<button i18n class="button-game button-game-max-width" (click)="toggleClicked.emit()">
    @if (videoEnabled) {
        Hide video
    } @else {
        Show video
    }
</button>
